(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Photo', Photo);

    Photo.$inject = ['$resource'];

    function Photo ($resource) {
        var resourceUrl =  'api/photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
